"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledSystem = require("styled-system");
var _default = (0, _styledSystem.style)({
  prop: 'outlineStyle'
});
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzdHlsZSIsInByb3AiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvY3VzdG9tUHJvcHMvb3V0bGluZVN0eWxlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHN0eWxlIH0gZnJvbSAnc3R5bGVkLXN5c3RlbSc7XG5cbmV4cG9ydCBkZWZhdWx0IHN0eWxlKHsgcHJvcDogJ291dGxpbmVTdHlsZScgfSk7XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBO0FBQXNDLGVBRXZCLElBQUFBLG1CQUFLLEVBQUM7RUFBRUMsSUFBSSxFQUFFO0FBQWUsQ0FBQyxDQUFDO0FBQUEifQ==